import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bulkGetLoyaltyCouponRequest = {};
var _bulkGetLoyaltyCouponResponse = { couponsInSite: '_couponsInSite' };
var _couponReference = { specification: '_specification' };
var _couponsInSite = { loyaltyCoupons: '_loyaltyCoupon' };
var _deleteLoyaltyCouponRequest = {};
var _deleteLoyaltyCouponResponse = {};
var _getCurrentMemberCouponsRequest = {};
var _getCurrentMemberCouponsResponse = { loyaltyCoupons: '_loyaltyCoupon' };
var _getLoyaltyCouponRequest = {};
var _getLoyaltyCouponResponse = { loyaltyCoupon: '_loyaltyCoupon' };
var _loyaltyCoupon = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    couponReference: '_couponReference',
};
var _queryLoyaltyCouponRequest = {};
var _queryLoyaltyCouponResponse = { loyaltyCoupons: '_loyaltyCoupon' };
var _redeemCurrentMemberPointsForCouponRequest = {};
var _redeemCurrentMemberPointsForCouponResponse = {
    coupon: '_loyaltyCoupon',
};
var _redeemMemberPointsForDiscountAmountCouponRequest = {
    specification: '_specification',
};
var _redeemMemberPointsForDiscountAmountCouponResponse = {
    coupon: '_loyaltyCoupon',
};
var _redeemPointsForCouponRequest = {};
var _redeemPointsForCouponResponse = { coupon: '_loyaltyCoupon' };
var _specification = {
    moneyOffAmount: 'DOUBLE',
    percentOffRate: 'DOUBLE',
    fixedPriceAmount: 'DOUBLE',
    minimumSubtotal: 'google.protobuf.DoubleValue',
};
function resolveComWixpressLoyaltyCouponLoyaltyCouponsUrl(opts) {
    var domainToMappings = {
        'manage._base_domain_': [
            {
                srcPath: '/_api/loyalty-coupons',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/loyalty-coupons',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/loyalty-coupons',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/loyalty-coupons',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/loyalty-coupons',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/loyalty-coupons',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/loyalty-coupons',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/loyalty-coupons',
                destPath: '',
            },
        ],
        '*.pub.wix-code.com': [
            {
                srcPath: '/_api/loyalty-coupons',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/loyalty-coupons',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/loyalty-coupons',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Redeems a customer's loyalty points for a loyalty reward and creates a loyalty coupon.
 *
 * Creating a loyalty coupon also creates a corresponding "reference" coupon with the [Coupons API](https://dev.wix.com/api/rest/coupons/about-wix-coupons).
 * The customer receives the reference coupon, which they can apply to their order. The loyalty coupon and its corresponding reference coupon
 * are linked and the loyalty coupon's `status` reflects the current state of the reference coupon.
 *
 * Check which loyalty rewards a site has available with [List Rewards](https://dev.wix.com/docs/rest/crm/loyalty-program/rewards/list-rewards).
 */
export function redeemPointsForCoupon(payload) {
    var _a = serializer(_redeemPointsForCouponRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_redeemPointsForCouponResponse, {
        _couponReference: _couponReference,
        _loyaltyCoupon: _loyaltyCoupon,
        _specification: _specification,
    }).fromJSON;
    function __redeemPointsForCoupon(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.coupon',
            method: 'POST',
            methodFqn: 'com.wixpress.loyalty.coupon.LoyaltyCoupons.RedeemPointsForCoupon',
            url: resolveComWixpressLoyaltyCouponLoyaltyCouponsUrl({
                protoPath: '/v1/coupons',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __redeemPointsForCoupon.fromReq = fromReq;
    __redeemPointsForCoupon.__isAmbassador = true;
    return __redeemPointsForCoupon;
}
/**
 * Redeems a current customer's loyalty points for a loyalty reward and creates a loyalty coupon.
 *
 * Creating a loyalty coupon also creates a corresponding "reference" coupon with the [Coupons API](https://dev.wix.com/api/rest/coupons/about-wix-coupons).
 * The customer receives the reference coupon, which they can apply to their order. The loyalty coupon and its corresponding reference coupon
 * are linked and the loyalty coupon's `status` reflects the current state of the reference coupon.
 *
 * Check which loyalty rewards a site has available with [List Rewards](https://dev.wix.com/docs/rest/crm/loyalty-program/rewards/list-rewards).
 *
 * >**Note:**
 * >This endpoint requires [visitor or member authentication](https://dev.wix.com/docs/rest/articles/getting-started/access-types-and-permissions).
 */
export function redeemCurrentMemberPointsForCoupon(payload) {
    var _a = serializer(_redeemCurrentMemberPointsForCouponRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_redeemCurrentMemberPointsForCouponResponse, { _couponReference: _couponReference, _loyaltyCoupon: _loyaltyCoupon, _specification: _specification }).fromJSON;
    function __redeemCurrentMemberPointsForCoupon(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.coupon',
            method: 'POST',
            methodFqn: 'com.wixpress.loyalty.coupon.LoyaltyCoupons.RedeemCurrentMemberPointsForCoupon',
            url: resolveComWixpressLoyaltyCouponLoyaltyCouponsUrl({
                protoPath: '/v1/coupons/redeem-my-coupon',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __redeemCurrentMemberPointsForCoupon.fromReq = fromReq;
    __redeemCurrentMemberPointsForCoupon.__isAmbassador = true;
    return __redeemCurrentMemberPointsForCoupon;
}
/**
 * Redeems a current customer's loyalty points for a loyalty reward and creates a loyalty coupon.
 *
 * Creating a loyalty coupon also creates a corresponding "reference" coupon with the [Coupons API](https://dev.wix.com/api/rest/coupons/about-wix-coupons).
 * The customer receives the reference coupon, which they can apply to their order. The loyalty coupon and its corresponding reference coupon
 * are linked and the loyalty coupon's `status` reflects the current state of the reference coupon.
 *
 * Check which loyalty rewards a site has available with [List Rewards](https://dev.wix.com/api/rest/wix-loyalty-program/rewards/list-rewards).
 */
export function redeemMemberPointsForDiscountAmountCoupon(payload) {
    var _a = serializer(_redeemMemberPointsForDiscountAmountCouponRequest, { _specification: _specification }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_redeemMemberPointsForDiscountAmountCouponResponse, { _couponReference: _couponReference, _loyaltyCoupon: _loyaltyCoupon, _specification: _specification }).fromJSON;
    function __redeemMemberPointsForDiscountAmountCoupon(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.coupon',
            method: 'POST',
            methodFqn: 'com.wixpress.loyalty.coupon.LoyaltyCoupons.RedeemMemberPointsForDiscountAmountCoupon',
            url: resolveComWixpressLoyaltyCouponLoyaltyCouponsUrl({
                protoPath: '/v1/coupons/redeem-discount-amount-coupon',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __redeemMemberPointsForDiscountAmountCoupon.fromReq = fromReq;
    __redeemMemberPointsForDiscountAmountCoupon.__isAmbassador = true;
    return __redeemMemberPointsForDiscountAmountCoupon;
}
/** Retrieves a loyalty coupon. */
export function getLoyaltyCoupon(payload) {
    var _a = serializer(_getLoyaltyCouponRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getLoyaltyCouponResponse, {
        _couponReference: _couponReference,
        _loyaltyCoupon: _loyaltyCoupon,
        _specification: _specification,
    }).fromJSON;
    function __getLoyaltyCoupon(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.coupon',
            method: 'GET',
            methodFqn: 'com.wixpress.loyalty.coupon.LoyaltyCoupons.GetLoyaltyCoupon',
            url: resolveComWixpressLoyaltyCouponLoyaltyCouponsUrl({
                protoPath: '/v1/coupons/{loyaltyCouponId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getLoyaltyCoupon.fromReq = fromReq;
    __getLoyaltyCoupon.__isAmbassador = true;
    return __getLoyaltyCoupon;
}
/** Retrieves a sequence of loyalty coupons */
export function bulkGetLoyaltyCoupon(payload) {
    var _a = serializer(_bulkGetLoyaltyCouponRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkGetLoyaltyCouponResponse, {
        _couponReference: _couponReference,
        _couponsInSite: _couponsInSite,
        _loyaltyCoupon: _loyaltyCoupon,
        _specification: _specification,
    }).fromJSON;
    function __bulkGetLoyaltyCoupon(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.coupon',
            method: 'GET',
            methodFqn: 'com.wixpress.loyalty.coupon.LoyaltyCoupons.BulkGetLoyaltyCoupon',
            url: resolveComWixpressLoyaltyCouponLoyaltyCouponsUrl({
                protoPath: '/v1/bulk/coupons',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData, true),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkGetLoyaltyCoupon.fromReq = fromReq;
    __bulkGetLoyaltyCoupon.__isAmbassador = true;
    return __bulkGetLoyaltyCoupon;
}
/**
 * Retrieves the loyalty coupons for the currently logged-in member.
 *
 * >**Note:**
 * >This endpoint requires [visitor or member authentication](https://dev.wix.com/docs/rest/articles/getting-started/access-types-and-permissions).
 */
export function getCurrentMemberCoupons(payload) {
    var _a = serializer(_getCurrentMemberCouponsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getCurrentMemberCouponsResponse, {
        _couponReference: _couponReference,
        _loyaltyCoupon: _loyaltyCoupon,
        _specification: _specification,
    }).fromJSON;
    function __getCurrentMemberCoupons(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.coupon',
            method: 'GET',
            methodFqn: 'com.wixpress.loyalty.coupon.LoyaltyCoupons.GetCurrentMemberCoupons',
            url: resolveComWixpressLoyaltyCouponLoyaltyCouponsUrl({
                protoPath: '/v1/coupons/my-coupons',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getCurrentMemberCoupons.fromReq = fromReq;
    __getCurrentMemberCoupons.__isAmbassador = true;
    return __getCurrentMemberCoupons;
}
/** Retrieves a list of loyalty coupons, given the provided paging, filtering, and sorting. */
export function queryLoyaltyCoupon(payload) {
    var _a = serializer(_queryLoyaltyCouponRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryLoyaltyCouponResponse, {
        _couponReference: _couponReference,
        _loyaltyCoupon: _loyaltyCoupon,
        _specification: _specification,
    }).fromJSON;
    function __queryLoyaltyCoupon(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.coupon',
            method: 'POST',
            methodFqn: 'com.wixpress.loyalty.coupon.LoyaltyCoupons.QueryLoyaltyCoupon',
            url: resolveComWixpressLoyaltyCouponLoyaltyCouponsUrl({
                protoPath: '/v1/coupons/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryLoyaltyCoupon.fromReq = fromReq;
    __queryLoyaltyCoupon.__isAmbassador = true;
    return __queryLoyaltyCoupon;
}
/**
 * Deletes a loyalty coupon.
 *
 * The deletion of a loyalty coupon does not impact the functionality of the corresponding coupon itself.
 */
export function deleteLoyaltyCoupon(payload) {
    var _a = serializer(_deleteLoyaltyCouponRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteLoyaltyCouponResponse, {}).fromJSON;
    function __deleteLoyaltyCoupon(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.loyalty.v1.coupon',
            method: 'DELETE',
            methodFqn: 'com.wixpress.loyalty.coupon.LoyaltyCoupons.DeleteLoyaltyCoupon',
            url: resolveComWixpressLoyaltyCouponLoyaltyCouponsUrl({
                protoPath: '/v1/coupons/{id}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteLoyaltyCoupon.fromReq = fromReq;
    __deleteLoyaltyCoupon.__isAmbassador = true;
    return __deleteLoyaltyCoupon;
}
//# sourceMappingURL=http.impl.js.map